// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b99b8ec6","49":"9da2829b","382":"11bd8de0","395":"55c8531f","551":"ad2aacc6","576":"ef7906fc","731":"ffc6c20f","766":"445b50fd","787":"e281d862","925":"148d8ddb"}[chunkId] + ".chunk.js";
};